export const reportStatusesColors = {
  'top_up_load_status.in_progress': 'darkgray',
  'top_up_load_status.success': 'green',
  'top_up_load_status.closed_with_errors': 'orange',
  'top_up_load_status.waiting_for_load_date': 'orange',
  'top_up_load_status.waiting_for_payment': 'orange',
  'top_up_load_status.payment_confirmed_waiting_for_load_date': 'darkgray',
  'top_up_load_status.payment_not_received': 'red',
  'top_up_load_status.expired': 'gray',
  'top_up_load_status.canceled': 'gray',
  'top_up_load_status.completed': 'green',
  'top_up_load_status.pending': 'orange',
  'top_up_load_status.failed': 'red',

  'card_order_status.1': 'darkgray',
  'card_order_status.3': 'darkgray',
  'card_order_status.5': 'red',
  'card_order_status.6': 'green',
  'card_order_status.7': 'gray',
  'card_order_status.8': 'red',

  'top_up_request_status.success': 'green',
  'top_up_request_status.error': 'red',
  'top_up_request_status.in_progress': 'darkgray',
  'top_up_request_status.not_started': 'gray',
  'top_up_request_status.expired': 'gray',
  'top_up_request_status.canceled': 'gray',
  'top_up_request_status.waiting_for_load_date': 'darkgray',
  'top_up_request_status.payment_not_received': 'red',
  'top_up_request_status.scheduled': 'darkgray',

  Created: 'orange',
  Closed: 'green',
  Canceled: 'gray',
  Expired: 'gray'
};
